// extracted by mini-css-extract-plugin
module.exports =  {"industries-picker":"ChRqDd8","industriesPicker":"ChRqDd8","suggestions":"e6BIRUf","industries-picker-mobile":"MpGTzV9","industriesPickerMobile":"MpGTzV9"};